import {Component, OnInit,ViewChildren,QueryList, Input,ElementRef} from '@angular/core';
import {Router} from '@angular/router';
import {first} from 'rxjs/operators';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators, FormArray} from '@angular/forms';

import {AuthenticationService} from '../../auth/_services/authentication.service';
import {DashboardComponent} from "../dashboard/dashboard.component";
import {PreloaderService} from "../../service/preloader.service";
import {UserReturningService} from "../../service/userReturning.service";
import {QuizService} from "../../service/quiz.service";
import {ChatService} from "../chat.service";


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    pinForm: FormGroup;
    phoneForm: FormGroup;

    phoneFormActive = true;
    phoneLastFour = '';
    numOfDigits = 6;

    popupShow = false;
    popupSuccess = false;
    popupMessage = '';
    kind = this.chatService.getChatKind();

    @ViewChildren('inputs') inputs: QueryList<ElementRef>;

    constructor(
        private formBuilder: FormBuilder,
        private fb: FormBuilder,
        private authenticationService: AuthenticationService,
        private preloaderService: PreloaderService,
        private quizService: QuizService,
        private chatService: ChatService,
        private userReturningService: UserReturningService,
        private router: Router) {

        this.pinForm = this.formBuilder.group({
            digits: this.formBuilder.array([])
        });


    }

    ngOnInit() {
        this.phoneForm = this.formBuilder.group({
            phone: [null, Validators.required]
        });

        for (let i = 0; i< this.numOfDigits; i++) {
            (this.pinForm.get('digits') as FormArray).push(this.formBuilder.control(null))
        }
    }

    resendSms(){
        this.onPhoneSubmit();
    }

    onPhoneSubmit(){
        if (this.phoneForm.invalid) {
            return;
        }

        let phone = this.phoneForm.controls.phone.value;

        this.popupShow = false;
        this.preloaderService.show();
        this.authenticationService.sendPin(phone).pipe(first()).subscribe(data => {
            this.preloaderService.hide();
            if(data.status){
                this.phoneLastFour = phone.substr(-4);

                this.phoneFormActive = false;

                let $this = this;
                setTimeout(function(){
                    $this.inputs.toArray()[0].nativeElement.focus();
                },0);
            }else{
                this.popupShow = true;
                this.popupSuccess = false;
                this.popupMessage = data.message;
            }
        });

    }

    onSubmit() {
        this.popupShow = false;
        if (this.pinForm.invalid) {
            return;
        }
        const kind = this.chatService.getChatKind();
        let phone = this.phoneForm.controls.phone.value;
        let pin = this.pinForm.controls.digits.value;
        pin = pin.join('');

        this.preloaderService.show();
        this.authenticationService.login(phone,pin, kind).pipe(first()).subscribe(data => {
            this.preloaderService.hide();
            if(data.status){
                this.router.navigate(['/profile']);
                // if (this.userReturningService.isReturning.value) {
                //    this.goToLastAnsweredQuestion();
                // } else {
                //     this.router.navigate(['/profile']);
                // }
            }else{
                this.popupShow = true;
                this.popupSuccess = false;
                this.popupMessage = data.message;
            }
        });
    }

    // goToLastAnsweredQuestion() {
    //     let questionId = 1;
    //
    //     this.quizService.getQuestionSteps().subscribe((data:any) => {
    //         if(data.status){
    //             data.result.forEach((el) => {
    //                 if (el.id > questionId && !el.hidden) {
    //                     questionId = el.id;
    //                 }
    //             });
    //             this.router.navigate([`/chat/${questionId}`]);
    //         }
    //     });
    // }

    isPhoneClassActive(){
        if(this.phoneFormActive){
            return true;
        }

        return false;
    }

    isPinClassActive(){
        if(!this.phoneFormActive){
            return true;
        }

        return false;
    }

    check(index, field, event) {
        if (isNaN(parseInt(event.key, 10)) && event.key !== 'Backspace') {
            event.preventDefault();
        }
        if (field.value && event.key !== 'Backspace') {
            if (index < this.inputs.toArray().length - 1) {
                this.inputs.toArray()[index + 1].nativeElement.focus();
            }
        }
        else if (event.key === 'Backspace') {
            if (index > 0) {
                field.setValue(null)
                this.inputs.toArray()[index - 1].nativeElement.focus();
            } else {
                console.log('first field');
            }
        }
    }

    goBack() {
        this.phoneFormActive = true;
        this.pinForm.reset();
    }

    goBackFromLoginPage(type?) {
        if (this.userReturningService.isReturning.value) {
            this.router.navigate(['/dashboard']);
        } else {
            this.router.navigate(['/dashboard'], {queryParams: {isBack: type}});
        }
    }
}
